// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1aHBD","name":"style_name__2ksrw","continfo":"style_continfo__pHuSg","badge":"style_badge__yXi_L"};